export type SynonymGroup = string[];

const DEFAULT_GROUPS: SynonymGroup[] = [
  ['job', 'occupation', 'profession', 'career'],
  ['child', 'kid', 'children'],
  ['buy', 'purchase', 'acquire'],
  ['important', 'crucial', 'vital', 'essential'],
  ['increase', 'raise', 'grow', 'boost'],
  ['reduce', 'decrease', 'lower', 'cut'],
  ['environment', 'ecosystem', 'nature'],
  ['education', 'schooling', 'learning'],
];

const WHITELISTS: Record<string, SynonymGroup[]> = {
  default: DEFAULT_GROUPS,
  // dataset specific ids from writing seeds (csvNumber) can map here as needed
  'csv-edu': [...DEFAULT_GROUPS, ['student', 'pupil', 'learner']],
};

const normalize = (value: string) => value.toLowerCase().trim();

export const buildSynonymIndex = (groups: SynonymGroup[]): Record<string, string> => {
  const index: Record<string, string> = {};
  for (const group of groups) {
    if (!group.length) continue;
    const [head, ...rest] = group.map(normalize).filter(Boolean);
    for (const term of [head, ...rest]) {
      index[term] = head;
    }
  }
  return index;
};

export function getSynonymWhitelist(id?: string | null): SynonymGroup[] {
  if (!id) return WHITELISTS.default;
  return WHITELISTS[id] ?? WHITELISTS.default;
}

